module.exports = __webpack_public_path__ + "static/media/biocertica-logo-default.96fc8e13.svg";